var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row menu_sticky"},[_c('Header')],1),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2"},[_c('Sidebar')],1),_c('div',{staticClass:"col-md-10 content pt-3 pb-3"},[_c('router-view')],1)]),_c('div',{staticClass:"row"},[_c('Footer')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }